// Contracts — self-service profile actions (F3/F4, 2026-08-11): the
// multi-role cabinet switcher and each person's own password change. Split
// from auth.ts because these act ON an existing session rather than being
// the sign-in surface itself.
import { z } from 'zod';
import { VistaPasswordSchema } from './auth';

// POST /api/vista/auth/as-contributor — a staff session exchanges itself for
// a CONTRIBUTOR session on the SAME email, so the profile-menu switcher can
// drive /my/* and /capture/* with a genuine contributor JWT instead of
// widening what the staff token itself may do (see apps/vista-api/CLAUDE.md:
// "session JWT unchanged"). No request body — the caller IS the account
// being exchanged. Response reuses VistaLoginResSchema (auth.ts): both are
// just "here is a token".
export const VistaAsContributorReqSchema = z.object({});
export type VistaAsContributorReq = z.infer<typeof VistaAsContributorReqSchema>;

// POST /api/vista/auth/password {password} — change the CALLER's own
// password. Works for either session kind: the handler tries the staff
// session first, then the contributor one (same order as every other
// dual-audience endpoint — handleAuthMe, handleAuthLogin). This is the
// self-service path; an admin resetting a CONTRIBUTOR's password still goes
// through PATCH /contributor/:id (manage.ts), and a manager resetting STAFF
// through PATCH /staff/:id — neither of those lets you set your own.
export const VistaChangePasswordReqSchema = z.object({ password: VistaPasswordSchema });
export type VistaChangePasswordReq = z.infer<typeof VistaChangePasswordReqSchema>;
